module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“B")])]), _vm._v("ooker, if you’re gonna die, at least have the decency to go home and do it there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Slumped over his desk, Gideon “Booker” Troyer kept his aching head pillowed on his forearms, but managed to cast a one-eyed glare at Craig Murphy, his friend and partner at Troyer Air Charter. “I’m fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And pigs can fly.” Craig advanced into Gideon’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If they pay cash I’ll fly them anywhere they want to go.” Gideon sat up. His less-than-witty comeback was followed by a ragged, painful cough. A bone-deep shiver shook his body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Craig took a step back. “You’re spreading germs, man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So leave.” Was a half hour of peace and quiet too much to ask? The drone of the television in the waiting area supplied just the right amount of white noise to let him drift off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re the one leaving—for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("home!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t go anywhere until this next load of freight gets here. Then I’m taking it to Caribou.” Gideon barely recognized his raspy voice. He sounded almost as bad as he felt. Almost.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If I was sick as a dog, you wouldn’t let me fly a kite, let alone your prize Cessna.”")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t like Gideon had a choice. Their business was finally showing a profit. A small one, but it was something to build on. He’d make today’s flight. If his austere Amish up-bringing had taught him anything, it was the value of hard work. “I’ve got a contract to fulfill.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shaking his head, Craig said, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("We’ve")]), _vm._v(" got a contract. I know you think you’re indispensable, Booker, but you’re not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The two men had known each other for six years, since their flight school days. It had been Craig who’d given Gideon his nickname on the first day of class. Gideon—Bible—the Book. Hence, Booker. Gideon had returned the favor a few weeks later when their trainer plane experienced mechanical trouble the first two times Craig took the controls. Craig was saddled with “Law” as in Murphy’s Law. If anything can go wrong, it will.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you offering to take this run?” Gideon took a swig of lukewarm coffee from the black mug on the corner of his desk. It turned into razor blades sliding down his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. Go home and get some rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gideon looked at him in surprise. “You mean that? I thought you had plans with Melody?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re sort of on the outs. Caribou in October will be warmer than the reception waiting for me the next time I see her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A woman’s voice from the other room said, “That’s because you’re a knucklehead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Craig rolled his eyes and raised his voice. “Stop giving people a piece of your mind, Roseanne. It’s almost gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gideon rose to his feet. The room spun wildly for a second before settling back into his cluttered office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Craig put out a hand to steady him. “You’re grounded, buddy. Not another word.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gideon hated to admit it, but he was in no shape to be in a cockpit. “Thanks, Law. I owe you one.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Craig leaned closer. “Roseanne is making me do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gideon cracked a grin. Their secretary’s powers of persuasion were legendary. She might look like someone’s cookie-baking grandmother with her gray hair pulled back in a bun, but she didn’t have a maternal bone in her body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll be back tomorrow,” Gideon promised.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roseanne came around Craig with Gideon’s coat in her hands. “You will not come back for a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gideon scowled at her. “Tell me again who’s the boss here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roseanne plopped her hands on her ample hips. “You two might own this business, but I run it. If I come down sick, we’re really in trouble. Who can handle the computer, the phone, the fax machine, invoices, accounts payable and the coffeepot all without leaving her chair?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You,” he and Craig said together.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gideon smiled. “You’re indispensable, Roseanne.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you’re sick. Get out of here and take this with you.” She held out a foam cup with a lid on it. “What’s this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your favorite brand of blackcurrant tea. I’d send some chicken soup home with you, but I don’t have any here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blackcurrant tea had been his mother’s surefire remedy for sore throats when he was growing up. He’d thought about sending her a box of this gourmet blend, but he knew she wouldn’t accept it. Not from the black sheep of the family. Gideon was the only one of her five children who’d left the Amish faith.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As if his thoughts of home brought up a connection, he heard the words "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amish country")]), _vm._v(" on the television. Glancing toward the small screen, he saw a female reporter, bundled against the brisk October chill, gesturing to a row of Amish buggies lined up behind her.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Roseanne, turn that up, please.” His voice was failing him. The words barely squeaked out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sighed, but picked up the remote and raised the sound level so he could hear the reporter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Preparations are under way in Hope Springs, Ohio, for this quiet Amish community’s largest event of the year. The Quilts of Hope charity auction is being held here this weekend.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Craig moved to stand beside Gideon. “Is that where you’re from?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nearby.” Hope Springs was forty miles from his father’s farm, but Gideon had never been there. Until he left the Amish he hadn’t traveled more than twenty miles from the farm where he was born. Now he lived in Rochester, New York, and he’d been to every state and all but one Canadian province.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The camera panned away from the buggies to a group of Amish men raising an enormous red-and-white-striped tent. After a second, the camera swung back to the reporter and followed her until she stopped in front of an intricately pieced quilt hanging on a display frame. “In the past, this event has raised thousands of dollars for the special needs of Amish families throughout Ohio. This year they are helping one of their own.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roseanne said, “Now, that’s pretty. I wouldn’t mind owning a quilt like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The reporter ran her hand down the cloth and the camera zoomed in to capture the details. “Rebecca Beachy is the Amish woman who made this incredible quilt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It can’t be.” In an instant, Gideon was transported back to his youth when he had courted the prettiest girl in Berlin, Ohio. The girl who broke his heart and turned him down flat when he’d finally found the courage to propose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Someone you know?” Craig asked.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. There are a lot of Beachys in Ohio. The girl I knew would be married to some Amish farmer or carpenter.” It was the life Rebecca wanted—as long as he wasn’t the farmer or the carpenter. Chances were slim that it was the same woman, but his gaze stayed glued to the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The camera switched to a group of Amish women who were talking. The women didn’t realize they were being filmed. They were dressed alike in dark coats and bonnets. One held a baby on her hip, but it was the woman in the center that he strained to see.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The reporter’s voice cut into Gideon’s thoughts. “The money from this year’s auction is going to help pay for some very specialized surgery for Miss Beachy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The camera zoomed in on the group of women and Rebecca’s face filled the television screen. The sight knocked the breath from his body. After almost ten years, his heart still ached at the sight of her. She was more beautiful than ever. Her heart-shaped face with those stunning high cheekbones had matured from the soft roundness of youth into a quiet elegance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why do they wear those odd white hats?” Roseanne asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s called a prayer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kapp.")]), _vm._v(" Amish women believe the Bible commands them to cover their hair when they pray.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But they don’t just wear them in church?” Roseanne turned to stare at him, waiting for an explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wanted to hear what the reporter was saying. “A woman might want to pray anytime, so she keeps her head covered all day. They never cut their hair, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca’s blond hair must be past her hips by now. He’d seen it down only once. It was the night he talked Rebecca into going to a hoedown with him and his rowdy friends.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hoedown")]), _vm._v(" was a benign name for a weekend-long party with loud music, alcohol and drugs attended by some of the ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("wilder Amish youth during their rumspringa, or running-around time. He had made the most of his rumspringa and partied hard. For Rebecca, that one party had been her only venture on the wild side.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gideon took the remote from his secretary and turned up the volume. The TV reporter droned on. “Miss Beachy stitched this beautiful quilt entirely by hand. What’s even more amazing is that she is totally blind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How on earth can a blind woman make a quilt?” Roseanne’s skeptical comment barely registered in Gideon’s brain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rebecca was blind?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly, he was gasping for air and coughing so hard his head pounded. It took a minute to catch his breath. Roseanne pulled the lid off the tea and offered him some. He took a grateful sip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Concern filled her eyes. “Do you know her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I once asked her to marry me. I think if she had said yes, I would be a bearded Amish farmer now.” With a blind wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca was blind. He couldn’t wrap his brain around the fact. Why? When had it happened? The thought of the vibrant woman he’d known living her life in darkness left an ache in his chest that had nothing to do with the flu. Before he could gather more details, the news program moved on to the weather forecast and warnings about an artic front plowing southward delivering early ice and snow in its wake.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Craig said, “I read the Amish don’t believe in health insurance. Is that true?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Most don’t. The community would rally round a family that had big medical expenses, but they could only do so much.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Gideon had to help. He pulled his phone from his pocket and prayed the news station could give him more information. It wasn’t until he tried to speak that he realized his voice was ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("gone. He handed the phone to Roseanne and wrote a quick note on a piece of paper from her desk.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Get me all the information you can about the auction.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After a brief conversation, Roseanne hung up and handed the notepad to him. “It’s at noon the day after tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That gave him one day to rest up. If he headed out early the following morning he could make the six-hour trip there and back. It would be a long day, but doable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Craig said, “Tell me you’re not going to drive to Ohio.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roseanne studied Gideon’s face. “Yes, he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know we’re going to have a wonderful time today.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca Beachy didn’t share her aunt Vera’s optimism. She folded her white cane and tucked it under her arm. Grasping her aunt’s elbow, she let Vera lead her toward the tent where the quilt auction was about to get under way. Besides Rebecca’s quilt, there were thirty others being auctioned off. Rebecca kept a smile on her face as she followed her aunt even though she was anything but comfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Disoriented by the noise and smells of the fairlike atmosphere, she wished she were back in her aunt’s small home where everything was in its rightful place and nothing was ready to trip her up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought had barely crossed her mind before something hit her legs and made her stumble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry,” a pair of childish voices called out. She heard their footsteps as the children ran away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hooligans,” Vera muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Excited "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kinder")]), _vm._v(" at play.” Rebecca listened to the sound of the children’s voices as they shouted to each other. A pang of longing escaped from the place in her heart where she kept her fading dreams.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Dreams she once had of being a wife and a mother, of holding a child of her own. She’d had the chance to make ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("those dreams come true years before, but she had been too afraid to take the risk. Had she made the right choice? Only God knew.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englisch")]), _vm._v(" children without manners,” Vera grumbled. “Come, we’re almost there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca drew a deep breath. Her life was what it was. This was God’s plan for her. Impossible dreams had no place in her dark world.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But if the darkness could be lifted?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t dare hope for such a miracle. This benefit auction was her aunt’s doing. Rebecca had tried to convince her the surgery was too expensive. They would need more money than would be raised here today. Even if they did manage to cover the cost, there was no guarantee her sight would be restored.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had argued long and hard to no avail. The auction was under way. It was all in God’s hands, but Rebecca didn’t believe He would produce a miracle for her. She was not worthy. She knew exactly why her sight had been taken from her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pulled the collar of her coat closed against a cold gust of wind and ugly memories. An early storm was on its way, but God had seen fit to hold it off until the auction was over. For that she was thankful. At least she and her aunt didn’t need to worry about traveling home in foul weather. They had already made plans to stay in town for several days.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Suddenly, the wind was blocked, and Rebecca knew they were inside the tent. It was warmer than she expected. The smells of hot dogs, popcorn, hot chocolate and coffee told her they were near the concession stand. The sound of hundreds of voices raised to be heard over the general din assaulted her ears. When they finally reached their seats, Rebecca unbuttoned her coat and removed her heavy bonnet. Many of the people around her greeted her in her native Pennsylvania ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Dutch. Leaning closer to her aunt, she asked, “Is my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kapp")]), _vm._v(" on straight? Do I look okay?”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And why wouldn’t you look okay?” Vera asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because I may have egg yolk from breakfast on my dress, or my backside may be covered with dust from the buggy seat. I don’t know. Just tell me I look presentable.” She knew everyone would be staring at her when her quilt was brought up for auction. She didn’t like being the center of attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You look lovely.” The harsh whisper startled her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned her face toward the sound coming from behind her and caught the scent of a man’s spicy aftershave. The voice must belong to an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englisch")]), _vm._v(" fellow. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Danki.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re most welcome.” He coughed and she realized he was sick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You sound as if you should be abed with that cold.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So I’ve been told,” he admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is a foolish fellow who doesn’t follow "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("goot")]), _vm._v(" advice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Some people definitely consider me foolish.” His raspy voice held a hint of amusement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was poking fun at himself. She liked that. There was something familiar about him but she couldn’t put her finger on what it was. “Have we met?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not from here,” he said quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vera said, “I see the bishop’s wife. I want to ask her how her brother is doing after his heart attack.” She rose and moved away, leaving Rebecca to her own devices. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englisch")]), _vm._v(" fellow said, “You’ve been deserted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She heard the folding chair beside her creak and his voice moved closer as if he were leaning over the seat. Although she knew it was unwise to encourage interaction with an outsider, she wanted to figure out why he seemed familiar. She wasn’t sure, but she thought she heard traces of a Pennsylvania Dutch accent in his raspy speech.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She said, “I don’t mind. I’m Rebecca Beachy.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a long hesitation, then he said, “My friends call me Booker. The quilts on display are beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you a collector, Mr. Booker, or did your wife make you come today? That’s often the case with the men in the audience, Amish and English alike.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not married. What about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nee,")]), _vm._v(" I am an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("alt maedel.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hardly an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("old")]), _vm._v(" maid. There must be something very wrong with the men in this community.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Flustered, she quickly changed the subject, but he had confirmed one suspicion. He understood at least a little of her native tongue. “Have you been to one of our auctions before?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, but I know what goes into making a quilt like the ones up on stage. My mother quilts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They do take a lot of effort. I’m glad people such as yourself appreciate our Amish workmanship. How did you hear about our auction?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I caught the story on WHAM.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Puzzled, she asked, “What is WHAM?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A television station where I live.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There was a story about our little auction on television?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, and about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She frowned. “Me? Why would they talk about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“According to the story, this auction is helping raise money for your eye surgery.” His voice was barely a whisper and fading.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Embarrassment overtook her. The heat of a blush rose up her neck and flared across her cheeks. “Perhaps Dr. White or his nurse, Amber Bradley, told them about me. I wish they had not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought it odd for an Amish person to seek publicity. The Amish normally shy away from the spotlight, don’t they?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("“We do not seek to draw attention to ourselves. We seek ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("only to live plain, humble lives. But you know that already, don’t you? How is it that you are familiar with our language?”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A long time ago I lived in a community that had Amish families.” His voice cracked on the last word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sympathy for him overrode her curiosity about his past. “You should rest your voice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long have you been blind?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was shocked by his abrupt personal question. Her reaction must have shown on her face because he immediately said, “I’m sorry. That was rude. It’s none of my business.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She rarely spoke about the time before she’d lost her sight. It was as if that life, filled with happiness, colors and the faces of the people she loved, belonged to another woman. Remembering the way she lost her sight always left her feeling depressed. It went bit by bit over the course of three years, first details and then colors, beloved faces and finally even the light. God had given her this burden. She must bear it well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Booker interrupted her moment of pity when he said, “I didn’t mean to pry. Please forgive me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He meant no harm. It was her pride and her inability to fully accept God’s will that made remembering painful. “You are forgiven. I learned I was going blind when I was twenty. My sight left me completely seven years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a long period of silence. What was he thinking? Did he feel sorry for her? Did he think she was helpless and useless? She rushed to dissuade him of such thoughts and repeated the words her bishop told her the day the last of her sight failed. “Do not think to pity me. My blindness has been a gift from God.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A gift meant to show her the error of her ways and lead her to repent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How can you call it a gift?” His scratchy voice broke. Because of his illness, or for some other reason?")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled sadly. “It is a struggle sometimes, but I know all that God gives us, whether hardship or happiness, is in some way a gift. We learn more about ourselves, and about how much we need God, during times of sorrow than we do in times of joy. I accept my life for what it is.” At least, she tried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But this surgery, it can restore your sight?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If God wills it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t you mean if the surgeon is skilled enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“God’s miracles come in many forms. If my sight is restored by the skill of an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englisch")]), _vm._v(" doctor or by a flash of lightning it is all the work of God.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then I pray He will be merciful. I wish you the very best, Rebecca Beachy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She heard his chair scoot back, then the sound of his footsteps until they blended into the hum of activity and voices inside the tent. A sharp sense of loss filled her but she didn’t understand why.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A few moments later, her aunt returned and sat down. Rebecca’s hand found Vera’s sleeve. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aenti,")]), _vm._v(" do you know the man that was just sitting here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What man?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was sitting in the row behind us. He’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englisch.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There are many "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Englisch")]), _vm._v(" here. I didn’t pay attention.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought perhaps he was someone I should know, but I didn’t recognize his name. He called himself Booker.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know anyone by that name. The bidding is getting ready to start. I pray your quilt does well. It’s lovely.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You picked the material. I merely stitched it together.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her aunt’s hands were twisted and gnarled with arthritis, making sewing and many daily tasks impossible for her. It was one reason why Rebecca chose to live with her aunt when her vision began to fade. She knew she could always be useful in her aunt’s household.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vera said, “I do wish you had put your Christmas Star quilt in the auction today. I’m sure it would fetch a fine price and we could use the money.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t wish to sell that one, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aenti.")]), _vm._v(" It will be a gift when it is done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was something special about the quilt she had been working on for the past several weeks. Something in the feel of the fabrics, the way the seams lay straight and true with so little effort. Her Christmas quilt would not be for sale. It would be a gift for a wedding or for someone’s birthday. She didn’t know who would receive it. God would show her in His own time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vera patted Rebecca’s hand. “Anyone that receives such a gift will be blessed. I pray it is God’s will to heal you, child. I pray that one day you may see with your own eyes the beauty you have crafted.”")])])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb14d692","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459282490_ch01.vue
// module id = 78
// module chunks = 0